import { safeParse } from './math';

/**
 * Formats a value into a CSS px size string.
 * @param val
 * @returns
 */
function format(val: string | number): string {
  val = safeParse(val);

  return val === 0 ? '0' : `${val}px`;
}

/**
 * Formats padding into CSS compatible shorthand string
 */
export function serializePadding(
  padding: Array<string | number> | number | string | Record<string, string | number>,
): string {
  if (typeof padding === 'number' || typeof padding === 'string') {
    // 单值
    return format(padding);
  }

  if (Array.isArray(padding)) {
    // [top, right, bottom, left]
    if (padding.length === 4) {
      const [t, r, b, l] = padding;
      if (t === b && r === l) {
        if (t === r) return format(t);
        return `${format(t)} ${format(r)}`;
      }
      if (r === l) return `${format(t)} ${format(r)} ${format(b)}`;
      return `${format(t)} ${format(r)} ${format(b)} ${format(l)}`;
    }
    // fallback: join all
    return padding.map(format).join(' ');
  }
  if (typeof padding === 'object' && padding !== null) {
    const t = padding.top ?? 0;
    const r = padding.right ?? 0;
    const b = padding.bottom ?? 0;
    const l = padding.left ?? 0;
    if (t === b && r === l) {
      if (t === r) return format(t);
      return `${format(t)} ${format(r)}`;
    }
    if (r === l) return `${format(t)} ${format(r)} ${format(b)}`;
    return `${format(t)} ${format(r)} ${format(b)} ${format(l)}`;
  }
  return '0';
}

/**
 * Parses a CSS padding string into an array of numbers [top, right, bottom, left]
 * @param padding
 * @returns
 */
export function parsePaddingString(padding: string | number): [number, number, number, number] {
  if (typeof padding === 'number') {
    return [padding, padding, padding, padding];
  }
  if (!padding || typeof padding !== 'string') {
    return [0, 0, 0, 0];
  }
  const parts = padding.trim().split(/\s+/);
  const values = parts.map((val) => {
    if (typeof val === 'number') return val;
    if (val.endsWith('px')) return safeParse(val);
    return safeParse(val);
  });
  switch (values.length) {
    case 1:
      return [values[0], values[0], values[0], values[0]];
    case 2:
      return [values[0], values[1], values[0], values[1]];
    case 3:
      return [values[0], values[1], values[2], values[1]];
    case 4:
      return [values[0], values[1], values[2], values[3]];
    default:
      return [0, 0, 0, 0];
  }
}
